"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'card',
  props: {
    isErrorBtn: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    handleRemove: function handleRemove() {
      this.$emit('handleRemove');
    },
    dragstart: function dragstart(e) {
      this.$emit('handleDragstart', e);
    },
    dragenter: function dragenter(e) {
      this.$emit('handleDragenter', e);
    }
  }
};